import * as actionType from '../constants/constant.action'

const defaultState = {}

const planDetailReducer = (state = defaultState, action) => {
  switch (action.type) {
    case actionType.GET_PLAN_DETAIL_ASYNC:
      return {
        ...state,
      }

    case actionType.GET_PLAN_DETAIL_REQUEST_SUCCESS:
      return {
        planDetail: {
          ...action.payload,
        },
      }

    case actionType.GET_PLAN_DETAIL_REQUEST_FAILURE:
      return {
        ...action.payload,
      }

    default:
      return state
  }
}

export default planDetailReducer
